export default "__VITE_ASSET__CVyhcicw__"